export default {
  boltAngle: 'boltAngle',
  boltTorque: 'boltTorque',
  currentDateTime: 'currentDateTime',
  hardwareName: 'hardwareName',
  scannedBarcode: 'scannedBarcode',
  userDefinedString: 'userDefinedString',
  variableDef: 'variableDef',
  selectedDecision: 'selectedDecision',
  sendImage: 'sendImage',
};
